import React from 'react';
import { PageContainer, PageFixer } from '@beef/smart-kit';
export var FTTBPageLayout = function FTTBPageLayout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(PageContainer, {
    size: "s",
    "data-t-id": "CatalogPage-_PageLayout"
  }, /*#__PURE__*/React.createElement(PageFixer, {
    size: "m",
    "data-t-id": "CatalogPage-_PageLayout"
  }, children));
};